/**
 * card-complex
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_card-complex.twig';
import './_card-complex.css';

export const name = 'card-complex';

export const defaults = {
  dummyClass: 'js-card-complex-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { cardComplex = {} }) {
  // Find our component within the DOM
  const $cardComplex = $('.card-complex', $context);
  // Bail if component does not exist
  if (!$cardComplex.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...cardComplex,
  };
  // An example of what could be done with this component
  $cardComplex.addClass(settings.dummyClass);
}

function initSliderInCard() {
  
  var parentLightBoxWrapper;
  var openedLightBoxEl;

  $('.slick-expand').on('click', function() {
    // Set parent wrapper 
    parentLightBoxWrapper = $(this).closest('.card-complex__gallery');

    // Detach ready to be appended
    var lightboxEl = $(this).closest('.card-complex__gallery').find('.card-complex__light-box-wrapper');
    var lightboxElClone = lightboxEl.detach();

    // Set close button
    var lightboxCloseEl = lightboxElClone.find('.slick-close');

    // Show lightbox
    lightboxElClone.appendTo('main.container');

    // Add delay for animation to happen after appending
    setTimeout(
      function() 
      {
        lightboxElClone.addClass("show-modal");
      }, 50);

    lightboxCloseEl.css("visibility", "visible");

    // Set detached lightboxEl
    openedLightBoxEl = lightboxElClone;
  });

  $('.slick-close').on('click', function() {
    // Close lightbox & append back to parent
    openedLightBoxEl.detach();
    openedLightBoxEl.prependTo(parentLightBoxWrapper);

    // Add delay for animation to happen after appending
    setTimeout(
      function() 
      {
        openedLightBoxEl.removeClass("show-modal");
      }, 50);
    openedLightBoxEl.css("visibility", "hidden");

  });
}

(function($, Drupal) {
  Drupal.behaviors.card_complex = {
    attach: function(context, settings) {

      /* Syncing preview slick and popup slick */
      $('.card-complex__light-box-wrapper').each(function( index ) {
        // parent container
        var parent = $(this).closest('.card-complex__gallery');

        // get popup slick
        var popupSlick = $(this).find('.slick');
        var popupSlickDiv = $(this).find('.slick > div');

        // get preview slick
        var previewSlick = parent.find('.slick--optionset--gallery-landscape');
        var previewSlickDiv = parent.find('.slick--optionset--gallery-landscape > div');

        // syncing the two
        previewSlick.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          popupSlickDiv.slick('slickGoTo', nextSlide);
        });
        popupSlick.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          previewSlickDiv.slick('slickGoTo', nextSlide);
        });
      });

    }
  };
}(global.jQuery, Drupal));

$(window).on('load', function() {
  initSliderInCard();
});

export default enable;
